import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AdminAuthProvider } from './context/AdminAuthContext';
import { AuthProvider } from './context/AuthContext';
import { WalletProvider } from './context/WalletContext';
import { PageLayout } from './components/layout/PageLayout';
import { AdminLayout } from './components/admin/AdminLayout';
import { BuyLottoPage } from './pages/BuyLottoPage';
import { WalletPage } from './pages/WalletPage';
import { RegisterPage } from './pages/RegisterPage';
import { LoginPage } from './pages/LoginPage';
import { YikiOverviewPage } from './pages/YikiOverviewPage';
import { YikiRoomPage } from './pages/YikiRoomPage';
import { SoiDaoOverviewPage } from './pages/SoiDaoOverviewPage';
import { SoiDaoRoomPage } from './pages/SoiDaoRoomPage';
import { LaoPattanaPage } from './pages/LaoPattanaPage';
import { LeaderboardPage } from './pages/LeaderboardPage';
import { ReferralPage } from './pages/ReferralPage';
import { AdminLoginPage } from './pages/AdminLoginPage';
import { AdminDashboardPage } from './pages/AdminDashboardPage';
import { AdminWalletPage } from './pages/AdminWalletPage';
import { AdminDrawLocksPage } from './pages/AdminDrawLocksPage';
import { AdminBetsPage } from './pages/AdminBetsPage';
import { AdminUsersPage } from './pages/AdminUsersPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { MyTicketsPage } from './pages/MyTicketsPage';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <WalletProvider>
          <AdminAuthProvider>
            <Routes>
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard" element={<AdminDashboardPage />} />
                <Route path="wallet" element={<AdminWalletPage />} />
                <Route path="draw-locks" element={<AdminDrawLocksPage />} />
                <Route path="bets" element={<AdminBetsPage />} />
                <Route path="users" element={<AdminUsersPage />} />
              </Route>
              <Route element={<PageLayout />}>
                <Route index element={<BuyLottoPage />} />
                <Route path="buy" element={<Navigate to="/" replace />} />
                <Route path="lao" element={<LaoPattanaPage />} />
                <Route path="yiki" element={<YikiOverviewPage />} />
                <Route path="yiki/:roomId" element={<YikiRoomPage />} />
                <Route path="soi-dao" element={<SoiDaoOverviewPage />} />
                <Route path="soi-dao/:roomId" element={<SoiDaoRoomPage />} />
                <Route path="tickets" element={<MyTicketsPage />} />
                <Route path="leaderboard" element={<LeaderboardPage />} />
                <Route path="referrals" element={<ReferralPage />} />
                <Route path="wallet" element={<WalletPage />} />
                <Route path="top-up" element={<Navigate to="/wallet" replace />} />
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Routes>
          </AdminAuthProvider>
        </WalletProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
